// extracted by mini-css-extract-plugin
export default {"wrapper":"Accordion_wrapper__bzBxf","disabled":"Accordion_disabled__2NgGB","button":"Accordion_button__MGztV","title":"Accordion_title__fyeMd","show":"Accordion_show__HX5t+"};